export class ProceedsFilter {
  constructor() {}
  automat = '';
  group = '';
  paymentType = -1;
  startDate: any = '';
  endDate: any = '';
}
